var map = {
	"./SkinAlex64x64.png": 28041,
	"./SkinAlexReference64x64.png": 90894,
	"./SkinSteveDiamondArmor64x64.png": 93665,
	"./SkinSteveReference64x64.png": 83721,
	"./Steve.png": 30259,
	"./axolotl_blue.png": 14620,
	"./axolotl_cyan.png": 35818,
	"./axolotl_gold.png": 79766,
	"./axolotl_lucy.png": 89248,
	"./axolotl_wild.png": 16874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75693;